module.exports = __webpack_public_path__ + "static/full04-3afe56f8182c8fac108a0f7d285e74bb.png";